import * as React from "react";
import { BaseComponent } from "../../../react-core/Html/BaseComponent";
import { TextBoxEditor } from "../../../react-core/Html/TextBoxEditor";
import { Alphabetical1, Alphabetical2, Numeric2 } from "../../../react-core/Html/Validation/RegExPatterns";
import { ValidatorContents } from "./ValidatorHelper";

interface ININumberTextEditorProps {
    value: string;
    onChange: (v) => void;
    label: string;
    readonly?: boolean;
}

interface ININumberTextEditorState {
    NationalNumber: string[];
}

export class NINumberTextEditor extends BaseComponent<ININumberTextEditorProps, ININumberTextEditorState> {
    constructor(props: ININumberTextEditorProps) {
        super(props);
        this.state = {
            NationalNumber: [null, null, null, null, null],
        };
    }

    componentDidMount() {
        const { NationalNumber } = this.state;
        const _data = this.props.value || "";
        for (let i = 0; i < NationalNumber.length; i++) {
            NationalNumber[i] = _data.substr(i * 2, 2);
        }
        this.setState({ NationalNumber });
    }

    moveToNextInput(cur: number, value: string) {
        if (value.length == 2) {
            const next = cur + 1;
            const nextInput = document.getElementById(`national-insurance-number-${next}`);
            nextInput.focus();
        }
    }

    public render(): JSX.Element {
        const { NationalNumber } = this.state;
        return (
            <fieldset>
                <legend className="control-label">{this.props.label}</legend>
                <div className="row narrow-gutter">
                    <div className="col-auto">
                        <TextBoxEditor
                            cssWrapper="control-size-60 label-sr-only"
                            label="1st and 2nd characters of National Insurance Number"
                            cssInput="text-center"
                            id="national-insurance-number-1"
                            errorsWrapperCss="isNIN-error-message"
                            placeholder="XX"
                            textCase="upper"
                            regex={{ errorMessage: "value must be two alphabets", value: Alphabetical2 }}
                            value={NationalNumber[0]}
                            disabled={this.props.readonly}
                            textLength={2}
                            onChange={(v) => {
                                if (v) {
                                    this.moveToNextInput(1, v);
                                    this.onNationalNumberChanges(0, v);
                                }
                            }}
                        />
                    </div>
                    <div className="col-auto">
                        <TextBoxEditor
                            cssWrapper="control-size-60 label-sr-only"
                            label="3rd and 4th characters of National Insurance Number"
                            cssInput="text-center"
                            errorsWrapperCss="isNIN-error-message"
                            id="national-insurance-number-2"
                            placeholder="00"
                            textLength={2}
                            disabled={this.props.readonly}
                            value={NationalNumber[1]}
                            regex={{ errorMessage: ValidatorContents.Numeric2, value: Numeric2 }}
                            onChange={(v) => {
                                if (v) {
                                    this.moveToNextInput(2, v);
                                    this.onNationalNumberChanges(1, v);
                                }
                            }}
                        />
                    </div>
                    <div className="col-auto">
                        <TextBoxEditor
                            cssWrapper="control-size-60 label-sr-only"
                            label="5th and 6th characters of National Insurance Number"
                            errorsWrapperCss="isNIN-error-message"
                            cssInput="text-center"
                            placeholder="00"
                            id="national-insurance-number-3"
                            textLength={2}
                            value={NationalNumber[2]}
                            disabled={this.props.readonly}
                            validateOnTyping
                            regex={{ errorMessage: ValidatorContents.Numeric2, value: Numeric2 }}
                            onChange={(v) => {
                                if (v) {
                                    this.moveToNextInput(3, v);
                                    this.onNationalNumberChanges(2, v);
                                }
                            }}
                        />
                    </div>
                    <div className="col-auto">
                        <TextBoxEditor
                            cssWrapper="control-size-60 label-sr-only"
                            label="7th and 8th characters of National Insurance Number"
                            errorsWrapperCss="isNIN-error-message"
                            cssInput="text-center"
                            id="national-insurance-number-4"
                            placeholder="00"
                            textLength={2}
                            disabled={this.props.readonly}
                            value={NationalNumber[3]}
                            regex={{ errorMessage: ValidatorContents.Numeric2, value: Numeric2 }}
                            onChange={(v) => {
                                if (v) {
                                    this.moveToNextInput(4, v);
                                    this.onNationalNumberChanges(3, v);
                                }
                            }}
                        />
                    </div>
                    <div className="col-auto">
                        <TextBoxEditor
                            cssWrapper="control-size-60 label-sr-only"
                            label="9th and 10th characters of National Insurance Number"
                            cssInput="text-center"
                            placeholder="X"
                            textLength={1}
                            errorsWrapperCss="isNIN-error-message"
                            id="national-insurance-number-5"
                            disabled={this.props.readonly}
                            regex={{ errorMessage: ValidatorContents.Alphabetical1, value: Alphabetical1 }}
                            textCase="upper"
                            value={NationalNumber[4]}
                            onChange={(v) => {
                                if (v) {
                                    this.onNationalNumberChanges(4, v);
                                }
                            }}
                        />
                    </div>
                </div>
            </fieldset>
        );
    }

    onNationalNumberChanges(index, value: string) {
        const _nationalNum = this.state.NationalNumber.concat();
        _nationalNum[index] = value;
        let result = "";
        _nationalNum.forEach((ele) => {
            if (!ele) {ele = "";}
            result += ele;
        });
        this.setState({ NationalNumber: _nationalNum });
        this.props.onChange(result);
    }
}
